import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { FilterCol, Order } from './ListFPARequest';

export interface IListFPATypeDocumentParsRequest extends IBaseRequest {
  limit?: number;
  offset?: number;
  orderBy?: string;
  countOnly?: boolean;
  FILTER?: FilterCol[];
  ORDER?: Order;
}

export class ListFPATypeDocumentParsRequest extends BaseRequest implements IListFPATypeDocumentParsRequest {
  public limit?: number;
  public offset?: number;
  public orderBy?: string;
  public countOnly?: boolean;
  public FILTER?: FilterCol[];
  public ORDER?: Order;

  constructor(server: string, session: string, otherOptions: any) {
    super(server, session);
    this.limit = otherOptions.limit;
    this.offset = otherOptions.offset;
    this.orderBy = otherOptions.orderBy;
    this.countOnly = otherOptions.countOnly;
    this.FILTER = otherOptions.FILTER;
    this.ORDER = otherOptions.ORDER;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.limit, 'limit');
    parameters += this.makeNode(this.offset, 'offset');
    parameters += this.makeNode(this.orderBy, 'orderBy');
    parameters += this.makeNode(this.countOnly, 'countOnly');
    if (this.FILTER) parameters += `<FILTER>${this.FILTER.map(filter => filter.toXml()).join('')}</FILTER>`;
    if (this.ORDER) parameters += this.ORDER.toXml();

    return super.wrapperXml('ListFPATypeDocumentPars', parameters);
  }
}
